const themeConfig = {
    darkTheme: false, 
	themes: {
		light: {
			primary: "#2D75BA",
			secondary: "#626273",
			accent: "#F37DAD",
			success: "#257659",
			info: "#4CC3D0",
			warning: "#F79F1F",
			error: "#E45D2B",
            border: "#212b49",
            //swal
            swalLight: "#FFFFFF",
            swalDark: "#6E6778",
		},
	},
}

export default themeConfig
